import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import type { FC } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationBrand from '@segment/templates/NavigationBrand'

import { DemoProvider } from '@segment/contexts/demo'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'

import ogImageJpeg from './assets/OgDemo.jpeg'

interface DemoRequestViewProps {
  beginsWithLeadEnrichmentForm?: boolean
}

const DemoRequestView: FC<DemoRequestViewProps> = ({ beginsWithLeadEnrichmentForm = false }) => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <DemoProvider>
        <Layout
          pageTitle="Request a Product Demo From Our Sales Team | Twilio Segment"
          pageDescription="Contact the Twilio Segment Sales team to request a product demo. Learn how Segment's customer data platform can collect, unify, and activate your data to help your business scale as you grow."
          pageOG={ogImageJpeg}
          themeColor={theme.palette.twilio.gray[10]}
          pageRobotsDirective="noindex"
        >
          <NavigationBrand />
          <Main>
            <Hero beginsWithLeadEnrichmentForm={beginsWithLeadEnrichmentForm} isDemoRequest={true} />
          </Main>
        </Layout>
        <Footer />
      </DemoProvider>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  /* Give a main content a background color, so sections don't flash from white background */
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default DemoRequestView
